import { useEffect } from 'react';
import { executeNoBodyRequest } from 'src/common/hooks/widgets/fetchData';
import { useEnv } from 'src/common/hooks/widgets/useEnv';

export interface emailProperties {
  emailFrom?: string;
  emailTo: string;
  emailCC?: string;
  emailSubject?: string;
  emailText: string;
  html?: string;
  attachments?: [
    {
      filename: string;
      path: string;
    },
  ];
}

// Note: variablesProperties must match the COS object structure stored in the remote service for this to
// work properly.
export interface variablesProperties {
  variables: {
    emailTo: string;
    emailSubject: string;
    hostingService: string;
  };
}

/**
 *
 */
export const useReadCOS = (
  feedback: string,
  setResponse: React.Dispatch<
    React.SetStateAction<{
      variables: {
        emailTo: string;
        emailSubject: string;
        hostingService: string;
      };
    }>
  >,
  emailJson: string,
) => {
  const [environment] = useEnv();
  const headers: any = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  };
  useEffect(() => {
    executeNoBodyRequest(
      `https://widgets-feedback.s3.us-east.cloud-object-storage.appdomain.cloud/${environment}${emailJson}`,
      'GET',
      headers,
    ).then((emailResponse) => {
      if (emailResponse.status === 200) {
        const content = JSON.stringify(emailResponse.message);
        const variables: variablesProperties = JSON.parse(content);
        setResponse(variables);
      } else {
        const result: variablesProperties = {
          variables: {
            emailTo: '',
            emailSubject: '',
            hostingService: '',
          },
        };
        setResponse(result);
      }
    });
  }, [feedback]);
};
